import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  appBar: {
    flexShrink: 0,
    zIndex: 0,
  },
  toolbar: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -20,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  grow: {
    flexGrow: 1,
  },
}));

export default styles;
